import {useQuery, UseQueryResult} from '@tanstack/react-query';
import TournamentRestClient from '@/Api/TournamentRestClient';
import {getLocalStorage} from '@/Utils/CommonUtils';

export function usePrizeTournamentsApi(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (data: any) => void,
): UseQueryResult<any, Error> {
  return useQuery({
    queryKey: ['prizeTournaments'],
    queryFn: async () => {
      const token = await getLocalStorage('access_token');
      const options = {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
        },
      };
      const res = await TournamentRestClient.get(
        '/tournament/get-prize-tournaments',
        options,
      );
      return res.data;
    },
    onSuccess: handleOnSuccess,
    onError: handleOnError,
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });
}
